export const mockData = {
  // Parent company level data
  parentCompanies: {
    'jungle-group': {
      id: 'jungle-group',
      name: 'The Jungle Group, INC',
      data: {
        totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
      }
    }
  },
  
  // Company/Seller Account level data - organized by parent company
  companyAccounts: {
    'jungle-group': {
      'tps-nutrients': {
        id: 'tps-nutrients',
        name: 'TPS Nutrients',
        data: {
          totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
          profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
        },
        groups: [
          {
            id: 'tps-nutrients-group',
            name: 'TPS Nutrients',
            data: {
              totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
            },
            products: [
              {
                brand: 'TPS',
                product: 'Lemon Tree',
                custom: 'Garden',
                stats: {
                  totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalReferralFeesPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalFbaFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
                },
                variations: [
                  {
                    brand: 'TPS',
                    product: 'Lemon Tree',
                    variation: '8oz',
                    custom: 'Garden',
                    stats: {
                      totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      totalReferralFeesPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      totalFbaFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                      profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
                    }
                  }
                ]
              },
              {
                brand: 'TPS',
                product: 'Hydrangea',
                custom: 'Garden',
                stats: {
                  totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalReferralFeesPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalFbaFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                  profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
                }
              }
            ]
          },
          {
            id: 'bloom-city',
            name: 'Bloom City',
            data: {
              totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
            }
          },
          {
            id: 'home-jungle',
            name: 'HomeJungle',
            data: {
              totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
              profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
            }
          }
        ]
      }
    }
  },
  
  // Legacy company data for backward compatibility
  companies: [
    {
      id: 'jungle',
      name: 'Jungle Co',
      data: {
        totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
      },
      brands: [
        {
          id: 'jungle-prime',
          name: 'Jungle Prime',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          },
          products: [
            {
              id: 'jungle-prime-xl',
              name: 'Jungle Prime XL',
              variation: 'XL',
              custom: 'Premium',
              data: {
                totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
              }
            }
          ]
        },
        {
          id: 'jungle-eco',
          name: 'Jungle Eco',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          }
        }
      ]
    },
    {
      id: 'tps',
      name: 'TPS Nutrients',
      brands: [
        {
          id: 'lemon-tree',
          name: 'Lemon Tree',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          },
          products: [
            {
              id: 'lemon-tree-8oz',
              name: 'Lemon Tree 8oz',
              variation: '8oz',
              custom: 'Garden',
              data: {
                totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
              }
            }
          ]
        },
        {
          id: 'hydrangea',
          name: 'Hydrangea',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          },
          products: [
            {
              id: 'hydrangea-16oz',
              name: 'Hydrangea 16oz',
              variation: '16oz',
              custom: 'Garden',
              data: {
                totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
              }
            }
          ]
        }
      ]
    },
    {
      id: 'bloom',
      name: 'Bloom City',
      data: {
        totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
      },
      brands: [
        {
          id: 'bloom-city',
          name: 'Bloom City',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          },
          products: [
            {
              id: 'bloom-premium',
              name: 'Bloom Premium',
              variation: 'Premium',
              custom: 'Flowers',
              data: {
                totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
              }
            }
          ]
        },
        {
          id: 'bloom-garden',
          name: 'Bloom Garden',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          }
        }
      ]
    },
    {
      id: 'home-jungle',
      name: 'Home-Jungle',
      data: {
        totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
        profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
      },
      brands: [
        {
          id: 'home-plants',
          name: 'Home Plants',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          },
          products: [
            {
              id: 'home-plants-starter',
              name: 'Home Plants Starter Kit',
              variation: 'Starter',
              custom: 'Indoor',
              data: {
                totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                tacos: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adImpressions: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adCpc: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adClicks: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adOrders: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpend: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                adSpendPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalReferralFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                cogs: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                avgSalePrice: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                totalFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                storageFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                inboundShippingFees: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPerUnit: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
                profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
              }
            }
          ]
        },
        {
          id: 'jungle-decor',
          name: 'Jungle Decor',
          data: {
            totalSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            unitsSold: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            aov: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            organicSales: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitPercent: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 },
            profitTotal: { week1: 0, week2: 0, week3: 0, week4: 0, week5: 0 }
          }
        }
      ]
    }
  ]
};

// Enhanced realistic mock data for development
export const generateRealisticData = (weeks = 10) => {
  const baseMetrics = {
    totalSales: 0,
    unitsSold: 0,
    tacos: 0,
    conversion: 0,
    organicSalesPercent: 0,
    adImpressions: 0,
    adCpc: 0,
    adClicks: 0,
    adSales: 0,
    adOrders: 0,
    adSpend: 0,
    adSpendPerUnit: 0,
    totalReferralFees: 0,
    inventory: 0,
    bsr: 0,
    cogs: 0,
    price: 0,
    avgSalePrice: 0,
    totalFbaFees: 0,
    totalFees: 0,
    storageFees: 0,
    inboundShippingFees: 0,
    profitPerUnit: 0,
    profitPercentage: 0,
    profitTotal: 0
  };

  const weeklyData = {};
  
  for (let week = 1; week <= weeks; week++) {
    weeklyData[`week${week}`] = Object.keys(baseMetrics).reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});
  }
  
  return weeklyData;
};